/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { ExtensibleNode } from '../../core/models/ExtensibleNode';
import { IReferenceNode } from '../../core/models/IReferenceNode';
import { INamed } from '../../core/models/common/INamed';
import { IVisitor } from '../../core/visitors/IVisitor';
import { IOasVisitor } from '../visitors/IOasVisitor';

/**
 * Constructor.
 * @param {string} name
 * @class
 * @extends ExtensibleNode
 * @author eric.wittmann@gmail.com
 */
export class OasResponse extends ExtensibleNode implements INamed, IReferenceNode {
    /*private*/ _name : string;

    public $ref : string;

    public description : string;

    public constructor(name : string) {
        super();
        if(this._name===undefined) this._name = null;
        if(this.$ref===undefined) this.$ref = null;
        if(this.description===undefined) this.description = null;
        this._name = name;
    }

    /**
     * Gets the response status code.
     * @return {string}
     */
    public getStatusCode() : string {
        return this.getName();
    }

    /**
     * @see io.apicurio.datamodels.core.models.Node#accept(io.apicurio.datamodels.core.visitors.IVisitor)
     * @param {*} visitor
     */
    public accept(visitor : IVisitor) {
        let viz : IOasVisitor = <IOasVisitor><any>visitor;
        viz.visitResponse(this);
    }

    /**
     * @see io.apicurio.datamodels.core.models.common.INamed#getName()
     * @return {string}
     */
    public getName() : string {
        return this._name;
    }

    /**
     * @see io.apicurio.datamodels.core.models.common.INamed#rename(java.lang.String)
     * @param {string} newName
     */
    public rename(newName : string) {
        this._name = newName;
    }

    /**
     * 
     * @return {string}
     */
    public getReference() : string {
        return this.$ref;
    }

    /**
     * 
     * @param {string} reference
     */
    public setReference(reference : string) {
        this.$ref = reference;
    }
}
OasResponse["__class"] = "io.apicurio.datamodels.openapi.models.OasResponse";
OasResponse["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable","io.apicurio.datamodels.core.models.IReferenceNode","io.apicurio.datamodels.core.models.common.INamed"];




